import React, { useState, Fragment, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Input, NumericTextBox } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import "./signatory-list.css";
import AutoCompleteSignerContainer from "../../actions/autocomplete-signer/AutoCompleteSignerContainer";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { GridSelectionHLPure, CheckBoxHLPure, SearchBarHLPure, DialogFormHLPure, ButtonHLPure, ButtonAddHLPure, InputHLPure, DialogDescriptionHLPure } from "../../pures"
import { Grid } from "@material-ui/core";
const TooltipContentTemplate = (props) => {
  return (
    <a>
      <p>{props.content}</p>
    </a>
  );
};

function DialogSignerContainer(props) {
  const { t } = useTranslation();
  const [isLoadig, setIsLoadig] = useState(false);
  const [showDialogNewCollaborator, setShowDialogNewCollaborator] = useState(false);
  const [usersGridSelected, setUsersGridSelected] = useState([])
  const [usersGridNotSelected, setUsersGridNotSelected] = useState([])
  const [dataUsers, setDataUsers] = useState(props.buttonType === 2 || props.buttonType === 4 ? props.collaboratorListAllow : props.inviteListAllow)
  const [selectedUser, setSelectedUser] = useState({})
  const [searchValue, setSearchValue] = useState([]);
  const [newListGridShow, setNewListGridShow] = useState(false);
  const [userFilter, setUsersGridFilter] = useState("")
  const [dataFilterGrid, setDataGridFilterGrid] = useState(props.signers)
  const [titleHeader, setTitleHeader] = useState(t("dialogSignerList2.addSigner"))
  const [showDescription, setShowDescription] = useState(false)
  const [btnAdd, setBtnAdd] = useState(t("signatureRequestView2.add.invited"))
  const [searchBtn, setSearchBtn] = useState(t("signatureRequestView2.search.invited"))
  const [description, setDescription] = useState('')
  const [dialogAddDescriptionActive, setDialogAddDescriptionActive] = useState(false)
  const [dialogAddDescription, setDialogAddDescription] = useState("")
  const [titleNewSigner, setTitleNewSigner] = useState(t("signatureRequestView2.new.colab"))
  const [firstInvites, setFirstInvites] = useState((props.buttonType === 2 || props.buttonType === 4) ? [] : props.inviteListAllow)

  const containerGroupButtonsStyles = {
    display: "inline-flex",
    justifyContent: "right",
    alignItems: "center",
    marginTop: "30px",
  };

  const styleGrid = {
    fontFamily: "Quicksand, sans-serif",
    maxHeight: "calc(50px * 5.5)",
    overflowY: "auto",
    overflowX: "hidden",
    overscrollBehavior: "contain",
    // border-block: 1px solid rgb(200, 200, 200) !important;
    borderRight: "1px solid rgb(200, 200, 200) !important",
    maxHeight: "301px"
  }

  const filterChangeUsers = (e) => {
    setUsersGridFilter(e.target.value)
  }

  // const filteredData =  dataUsers.filter((item) =>
  //     item.name.toLowerCase().includes(userFilter.toLowerCase()) );

  const onChangeCheckBox = (event, dataItem) => {
    //Array users
    const updatedData = dataUsers.map((item) => {
      if (item.id === dataItem.id) {
        return { ...item, isAssigned: event.target.checked };
      }
      return item;
    });
    setDataUsers(updatedData);
    // user.id === dataItem.id ? { ...user, isAssigned: event.target.checked } : user)
    // setDataUsers(copyUsers)

    //Array users not selected
    let filteredDataNotSelected = updatedData.filter(item => item.isAssigned === false);
    setUsersGridNotSelected(filteredDataNotSelected)
    //Array selected users
    let selectedDataItems = updatedData.filter(item => item.isAssigned);
    setUsersGridSelected(selectedDataItems)
    setNewListGridShow(true)
  }

  useEffect(() => {
    if (usersGridSelected.length > 0) {
      props.saveArraSelectedList(usersGridSelected, usersGridNotSelected)
    }
  }, [usersGridSelected, usersGridNotSelected])

  useEffect(() => {
  }, [dataUsers])


  useEffect(() => {
    const eliminarObjetosIguales = () => {
      const objetosDiferentes = dataUsers.filter(dataUserItem => {
        const objeto2 = dataFilterGrid.find(dataFilterGridItem => dataFilterGridItem.email === dataUserItem.email);
        return !objeto2;
      });
      setSearchValue(objetosDiferentes)
    };
    eliminarObjetosIguales();
  }, [dataUsers, dataFilterGrid]);

  useEffect(() => {
    let title = ''
    let showDescription = false
    let btnAdd = t("signatureRequestView2.add.invited")
    let btnSearch = t("signatureRequestView2.search.invited")
    let description = t("dialogSignerList2.invitationmessage")
    let titleNewSigner = t("signatureRequestView2.new.colab")
    let dialogDescription = ""
    let dialogDescriptionActive = false

    switch (props.buttonType) {
      case 0:
        title = t("dialogSignerList2.addSigner")
        showDescription = true
        description = t("dialogSignerList2.invitationmessage")
        titleNewSigner = t("signatureRequestView2.new.invited")
        break;
      case 2:
        title = t("dialogSignerList2.addCollaborator")
        btnAdd = t("signatureRequestView2.add.colab")
        btnSearch = t("signatureRequestView2.search.colab")
        titleNewSigner = t("signatureRequestView2.new.colab")
        break;
      case 4:
        title = t("dialogSignerList2.addValidator")
        btnAdd = t("signatureRequestView2.add.colab")
        btnSearch = t("signatureRequestView2.search.colab")
        titleNewSigner = t("signatureRequestView2.new.colab")
        break;
      case 5:
        title = t("signatureRequestView2.add.signers.no.password")
        btnAdd = t("signatureRequestView2.add.signer.no.password")
        showDescription = true
        btnSearch = t("Buscar firmante")
        description = t("signatureRequestView2.description.signer.no.password")
        titleNewSigner = t("signatureRequestView2.title.new.signer.no.password")
        dialogDescription = t("signatureRequestView2.title.invited_signer.no_description")
        dialogDescriptionActive = true
        break;
      default:
        title = t("dialogSignerList2.addSigner")
        showDescription = true
        btnAdd = t("signatureRequestView2.add.invited")
        btnSearch = t("signatureRequestView2.search.invited")
        description = t("dialogSignerList2.invitationmessage")
        titleNewSigner = t("signatureRequestView2.new.colab")
        break;
    }

    setTitleHeader(title)
    setShowDescription(showDescription)
    setBtnAdd(btnAdd)
    setSearchBtn(btnSearch)
    setDescription(description)
    setTitleNewSigner(titleNewSigner)
    setDialogAddDescription(dialogDescription)
    setDialogAddDescriptionActive(dialogDescriptionActive)
  }, [props.buttonType])

  const filteredData = searchValue.filter((item) =>
    item.name.toLowerCase().includes(userFilter.toLowerCase()) || item.email.toLowerCase().includes(userFilter.toLowerCase()));

  const onClickNewCollaborator = () => {
    setShowDialogNewCollaborator(true)
    // props.cancel()
  }

  const headerColumnOne = (props) => {
    let styleHeader = {
      color: "#123513",
      fontSize: "14px",
      fontWeight: 600,
      display: "flex",
      justifyContent: "start",
      fontFamily: "Quicksand",
      paddingLeft: '20px',
    };
    return <span style={styleHeader}>{props.title}</span>;
  };

  const cellColumnOne = (props) => {
    return (
      <td className="dialogSigner-cell-one">
        <div className="dialogSigner-cell-one-div">
          <CheckBoxHLPure
            valueCheckBox={props.dataItem}
            checkedState={props.dataItem.isAssigned}
            onChangeHandler={(event) => onChangeCheckBox(event, props.dataItem)}
          />
          <div className="text-double">
            <span className="dialogSigner-containerLabel">
              {props.dataItem.name}
            </span>
            <span className="dialogSigner-subtitle-containerLabel">
              {props.dataItem.email}
            </span>
          </div>
        </div>
      </td>
    );
  };

  const searchByEmail = async (e) => {
    let value = e.target.value

    if (!value) setDataUsers(firstInvites)
    if (value && value.length === 4) {
      let invitesCollabs = await props.getCollabsOrInvites(2, null, null, value)
      let invites = (invitesCollabs && invitesCollabs.invites) ? invitesCollabs.invites : []
      setDataUsers(invites)
    }

    setUsersGridFilter(value)
  }

  const onKeyPress = async (e) => {
    if (!userFilter || props.buttonType === 2 || props.buttonType === 4 || userFilter.length < 4) return
    if (e.key === "Enter") {
      e.preventDefault();
      let invitesCollabs = await props.getCollabsOrInvites(2, null, null, userFilter)
      let invites = (invitesCollabs && invitesCollabs.invites) ? invitesCollabs.invites : []
      setDataUsers(invites)
    }
  }

  return (
    <div
      style={
        props.showErrorDomain === true || props.showErrorDomainInvited === true
          ? { display: "none" }
          : null
      }
    >
      <Fragment>
        {!showDialogNewCollaborator ?
          <DialogFormHLPure
            className="custom-title invitation-modal"
            titleDialog={titleHeader}
            descriptionActive={showDescription}
            descriptionDialog={description}
            textBtnCancel={t("button.cancel")}
            cancel={props.cancel}
            saveBtn={t("button.accept")}
            handleSubmit={props.handleSubmitList}

          >
            <div className="dialog-invitation-form">
              <div className="dialogSigner-formButtons">
                <ButtonAddHLPure
                  nameBtn={btnAdd}
                  onClickBtn={onClickNewCollaborator}
                  iconAdd={true}
                />
                <SearchBarHLPure
                  placeholder={searchBtn}
                  onSearchChange={(props.buttonType === 2 || props.buttonType === 4) ? (e) => filterChangeUsers(e) : (e) => searchByEmail(e)}
                  searchValue={userFilter}
                  tooltip={!(props.buttonType === 2 || props.buttonType === 4)}
                  positionTooltip={'right'}
                  titleTooltip={t("dialogSignerList2.tooltip.title")}
                  descriptionTooltip={t("dialogSignerList2.tooltip.description")}
                  informationIcon={!(props.buttonType === 2 || props.buttonType === 4)}
                  onKeyPress={(e) => onKeyPress(e)}
                />
              </div>
              <div className="dialog-invitation-grid">
                <GridSelectionHLPure
                  skip={0}
                  take={6}
                  dataGrid={filteredData}
                  filter={true}
                  onFilterChange={filterChangeUsers}
                  onSelectedItem={selectedUser}
                  styleGrid={styleGrid}
                  cellColumnOne={cellColumnOne}
                  headerColumnOne={headerColumnOne}
                  widthColumnOne={100}
                  // setNameComponentUser={setNameComponentUser}
                  // setShowDetails={setShowDetails}
                  // isCheckedColOne="isAssigned"
                  pageable={false}
                  isCheckedColOne={""}
                  styleGeneral
                  styleGeneralClass="dialog-signer-gridSelectionGLPure"
                // dataUsers={setDataUsers}
                />
              </div>
            </div>
          </DialogFormHLPure>
          : (
            <DialogFormHLPure
              descriptionActive={dialogAddDescriptionActive}
              descriptionDialog={dialogAddDescription}
              titleDialog={titleNewSigner}
              cancel={props.cancel}
              showChildrenBottom
              childrenBottom={<>
                <Grid className="dialogFormHLPure-buttons">
                  <ButtonHLPure
                    nameBtn={t("button.return")}
                    onClickBtn={props.cancel}
                  />
                  <ButtonHLPure
                    primary={true}
                    nameBtn={t("button.save")}
                    onClickBtn={props.handleSubmit}
                  />
                </Grid>
              </>
              }
            >
              {props.buttonType !== 5
                ?
                <div className="dialog-invitation-form">
                  <div style={{ marginBottom: "14px", lineHeight: "1" }}>
                    <InputHLPure
                      typeInput="email"
                      labelInput={t("dialogSignerList2.email")}
                      inputTypeBox={false}
                      valueInput={props.signerInEdit.email || ""}
                      handleChangeInput={(event) => props.changeSignerEmailInEdit(event)}
                      // valueInput={address}
                      // handleChangeInput={(e) => handleChangeEmail(e)}
                      // errorInputText="Error esta al el text"
                      // informationIcon
                      inputActive
                    />

                    {props.errorCurrentEmail === true && (
                      <span className="hint-message-error">
                        {t("dialogSignerList2.errorEmailNotvalid")}
                      </span>
                    )}
                    {props.errorCurrentEmailRegister === true &&
                      props.errorCurrentEmail === false && (
                        <span className="hint-message-error">
                          {t("dialogSignerList2.errorEmailAlreadyRegister")}
                        </span>
                      )}
                  </div>
                  <div style={{ marginBottom: "14px", lineHeight: "1" }}>
                    <Label className="dialog-signers-labels">
                      {t("dialogSignerList2.name")}
                    </Label>
                    <div>
                      <Input
                        className="input-add-colaborator"
                        type="name"
                        name="nameSigner"
                        disabled={isLoadig}
                        // required={true}
                        minLength={2}
                        value={props.signerInEdit.nameSigner || ""}
                        onChange={(event) => props.onDialogInputChange(event)}
                        validator={props.validator.nameValidator}
                        component={props.validateInput}
                      />
                    </div>
                    {props.errorCurrentName && (
                      <span className="hint-message-error">
                        {t("dialogSignerList2.errorFirstNamesNotvalid")}
                      </span>
                    )}
                  </div>
                  <div style={{ marginBottom: "14px", lineHeight: "1" }}>
                    <Label className="dialog-signers-labels">
                      {t("dialogSignerList2.lastName")}
                    </Label>
                    <Input
                      className="input-add-colaborator"
                      type="name"
                      name="lastNameSigner"
                      // required={true}
                      minLength={2}
                      disabled={isLoadig}
                      value={props.signerInEdit.lastNameSigner || ""}
                      onChange={(event) => props.onDialogInputChange(event)}
                      validator={props.validator.nameValidator}
                      component={props.validateInput}
                    // onKeyPress={function (e) {
                    //   if (e.key === "Enter") {
                    //     props.handleSubmit(e)
                    //   }
                    // }}
                    />

                    {props.errorCurrentLastName && (
                      <span className="hint-message-error">
                        {t("dialogSignerList2.errorLastNamesNotvalid")}
                      </span>
                    )}
                  </div>
                </div>
                :
                <div className="dialog-invitation-form">
                  <div style={{ marginBottom: "14px", lineHeight: "1" }}>
                    <InputHLPure
                      typeInput="email"
                      labelInput={t("signatureRequestView2.invited_signer_no_password.email")}
                      inputTypeBox={false}
                      valueInput={props.signerInEdit.email || ""}
                      handleChangeInput={(event) => props.changeSignerEmailInEdit(event)}
                      // valueInput={address}
                      // handleChangeInput={(e) => handleChangeEmail(e)}
                      // errorInputText="Error esta al el text"
                      // informationIcon
                      inputActive
                    />

                    {props.errorCurrentEmail === true && (
                      <span className="hint-message-error">
                        {t("dialogSignerList2.errorEmailNotvalid")}
                      </span>
                    )}
                    {props.errorCurrentEmailRegister === true &&
                      props.errorCurrentEmail === false && (
                        <span className="hint-message-error">
                          {t("dialogSignerList2.errorEmailAlreadyRegister")}
                        </span>
                      )}
                  </div>

                  <div style={{ marginBottom: "14px", lineHeight: "1" }}>
                    <Label className="dialog-signers-labels">
                      {t("signatureRequestView2.invited_signer_no_password.names")}
                    </Label>
                    <div>
                      <Input
                        className="input-add-colaborator"
                        type="name"
                        name="nameSigner"
                        disabled={isLoadig}
                        // required={true}
                        minLength={2}
                        value={props.signerInEdit.nameSigner || ""}
                        onChange={(event) => props.onDialogInputChange(event)}
                        validator={props.validator.nameValidator}
                        component={props.validateInput}
                      />
                    </div>
                    {props.errorCurrentName && (
                      <span className="hint-message-error">
                        {t("dialogSignerList2.errorFirstNamesNotvalid")}
                      </span>
                    )}
                  </div>

                  <div style={{ marginBottom: "14px", lineHeight: "1" }}>
                    <Label className="dialog-signers-labels">
                      {t("signatureRequestView2.invited_signer_no_password.firstLastName")}
                    </Label>
                    <Input
                      className="input-add-colaborator"
                      type="name"
                      name="firstLastNameSigner"
                      // required={true}
                      minLength={2}
                      disabled={isLoadig}
                      value={props.signerInEdit.firstLastNameSigner || ""}
                      onChange={(event) => props.onDialogInputChange(event)}
                      validator={props.validator.nameValidator}
                      component={props.validateInput}
                    // onKeyPress={function (e) {
                    //   if (e.key === "Enter") {
                    //     props.handleSubmit(e)
                    //   }
                    // }}
                    />

                    {props.errorCurrentLastName && (
                      <span className="hint-message-error">
                        {t("signatureRequestView2.invited_signer_no_password.errorFirstLastName")}
                      </span>
                    )}
                  </div>

                  <div style={{ marginBottom: "14px", lineHeight: "1" }}>
                    <Label className="dialog-signers-labels">
                      {t("signatureRequestView2.invited_signer_no_password.secondLastName")}
                    </Label>
                    <Input
                      className="input-add-colaborator"
                      type="name"
                      name="secondLastNameSigner"
                      // required={true}
                      minLength={2}
                      disabled={isLoadig}
                      value={props.signerInEdit.secondLastNameSigner || ""}
                      onChange={(event) => props.onDialogInputChange(event)}
                      validator={props.validator.nameValidator}
                      component={props.validateInput}
                    // onKeyPress={function (e) {
                    //   if (e.key === "Enter") {
                    //     props.handleSubmit(e)
                    //   }
                    // }}
                    />

                    {props.errorCurrentLastName && (
                      <span className="hint-message-error">
                        {t("signatureRequestView2.invited_signer_no_password.errorSecondLastName")}
                      </span>
                    )}
                  </div>
                  <div style={{ marginBottom: "14px", lineHeight: "1" }}>
                    <Label className="dialog-signers-labels">
                      {t("signatureRequestView2.invited_signer_no_password.phoneNumber")}
                    </Label>
                    <Input
                      className="input-add-colaborator"
                      type="name"
                      name="phoneNumber"
                      // required={true}
                      minLength={2}
                      disabled={isLoadig}
                      value={props.signerInEdit.phoneNumber || ""}
                      onChange={(event) => props.onDialogInputChange(event)}
                      validator={props.validator.nameValidator}
                      component={props.validateInput}
                    // onKeyPress={function (e) {
                    //   if (e.key === "Enter") {
                    //     props.handleSubmit(e)
                    //   }
                    // }}
                    />

                    {props.errorCurrentLastName && (
                      <span className="hint-message-error">
                        {t("signatureRequestView2.invited_signer_no_password.errorPhoneNumber")}
                      </span>
                    )}
                  </div>
                </div>
              }
            </DialogFormHLPure>
          )}
      </Fragment>
    </div>
  );
}

export { DialogSignerContainer as default };
